import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { IconDelete } from '../../components/icons';

export default function Moderation() {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmRemoveId, setConfirmRemoveId] = useState(null);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const data = await api.request('/recipes/flagged');
      setRecipes(data.recipes || []);
    } finally {
      setLoading(false);
    }
  }

  async function review(id, action) {
    setConfirmRemoveId(null);
    await api.request(`/recipes/${id}/review`, {
      method: 'POST',
      body: JSON.stringify({ action }),
    });
    setRecipes(prev => prev.filter(r => r.id !== id));
  }

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '1.4rem', marginBottom: '0.25rem' }}>🚨 Moderation</h1>
        <p style={{ color: 'var(--text-light)', fontSize: '0.875rem' }}>
          Vom Content-Scanner geflaggte Rezepte — täglich 03:00 Uhr aktualisiert.
        </p>
      </div>

      {loading && <p style={{ color: 'var(--text-light)' }}>Lädt…</p>}

      {!loading && recipes.length === 0 && (
        <div style={{
          background: 'color-mix(in srgb, var(--admin-success) 12%, transparent)', border: '1.5px solid var(--admin-success)',
          borderRadius: 'var(--radius)', padding: '2rem', textAlign: 'center'
        }}>
          <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>✅</div>
          <strong style={{ color: 'var(--admin-success)' }}>Keine auffälligen Rezepte</strong>
          <p style={{ color: 'var(--admin-success)', fontSize: '0.875rem', marginTop: '0.25rem' }}>
            Alle Inhalte haben den Scan bestanden.
          </p>
        </div>
      )}

      {recipes.map(r => (
        <div key={r.id} style={{
          background: 'var(--admin-bg)', border: '1.5px solid var(--admin-danger)',
          borderRadius: 'var(--radius)', padding: '1.25rem',
          marginBottom: '1rem', display: 'flex', gap: '1rem', alignItems: 'flex-start'
        }}>
          {r.image_path && (
            <img src={r.image_path} alt=""
              style={{ width: 80, height: 80, objectFit: 'cover',
                       borderRadius: 6, flexShrink: 0, border: '1px solid var(--border)' }} />
          )}

          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap', marginBottom: '0.35rem' }}>
              <strong style={{ fontSize: '1rem' }}>{r.title}</strong>
              <span style={{
                fontSize: '0.72rem', background: 'color-mix(in srgb, var(--admin-danger) 15%, transparent)', color: 'var(--admin-danger)',
                padding: '0.15rem 0.5rem', borderRadius: 20, fontWeight: 600
              }}>
                {r.is_public ? 'Öffentlich' : 'Privat'}
              </span>
            </div>
            <div style={{ fontSize: '0.8rem', color: 'var(--text-light)', marginBottom: '0.5rem' }}>
              Nutzer: <strong>{r.username}</strong>
              {r.flagged_at && <> · Geflaggt: {new Date(r.flagged_at).toLocaleString('de-AT')}</>}
            </div>
            <div style={{
              fontSize: '0.85rem', background: 'color-mix(in srgb, var(--admin-accent) 12%, transparent)', border: '1px solid var(--admin-accent)',
              borderRadius: 6, padding: '0.5rem 0.75rem', color: 'var(--admin-accent)',
              marginBottom: '0.75rem'
            }}>
              <strong>Grund:</strong> {r.flag_reason || '–'}
            </div>

            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <a href={`/recipe/${r.id}`} target="_blank" rel="noopener noreferrer"
                className="btn btn-secondary" style={{ fontSize: '0.8rem', padding: '0.4rem 0.85rem' }}>
                🔍 Ansehen
              </a>
              <button onClick={() => review(r.id, 'approve')}
                className="btn btn-primary" style={{ fontSize: '0.8rem', padding: '0.4rem 0.85rem', background: 'var(--admin-success)', borderColor: 'var(--admin-success)' }}>
                ✅ Freigeben
              </button>
              {confirmRemoveId === r.id ? (
                <>
                  <button onClick={() => review(r.id, 'remove')}
                    className="btn" style={{ fontSize: '0.8rem', padding: '0.4rem 0.85rem', background: 'var(--admin-danger)', borderColor: 'var(--admin-danger)', color: '#fff' }}>
                    Ja, endgültig löschen
                  </button>
                  <button onClick={() => setConfirmRemoveId(null)}
                    className="btn btn-secondary" style={{ fontSize: '0.8rem', padding: '0.4rem 0.85rem' }}>
                    Abbrechen
                  </button>
                </>
              ) : (
                <button onClick={() => setConfirmRemoveId(r.id)}
                  className="btn" style={{ fontSize: '0.8rem', padding: '0.4rem 0.85rem', background: 'var(--admin-danger)', borderColor: 'var(--admin-danger)', color: '#fff' }}>
                  <IconDelete size={14} /> Löschen
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
